import React from "react";

import StatsCard from "js/components/StatsCard";
import { Credits } from "js/pages/Organization/types";

const CreditCardSection: React.FC<{
  credits: Credits;
  position?: "start" | "end";
}> = ({ credits, position = "end" }) => {
  const creditConfigs: {
    [key: string]: {
      label: string;
      icon: string;
      helperText?: string;
      accent: {
        iconBg: string;
        iconText: string;
        iconRing?: string;
      };
    };
  } = {
    pf: {
      label: "Persona Física",
      icon: "octicon:person-24",
      helperText: "Créditos disponibles",
      accent: {
        iconBg: "bg-sky-50",
        iconText: "text-sky-600",
        iconRing: "ring-1 ring-inset ring-sky-100",
      },
    },
    pm: {
      label: "Persona Moral",
      icon: "octicon:organization-24",
      helperText: "Créditos disponibles",
      accent: {
        iconBg: "bg-violet-50",
        iconText: "text-violet-600",
        iconRing: "ring-1 ring-inset ring-violet-100",
      },
    },
    tenant_pf: {
      label: "Inquilino PF",
      icon: "octicon:person-24",
      helperText: "Solicitudes disponibles",
      accent: {
        iconBg: "bg-emerald-50",
        iconText: "text-emerald-600",
        iconRing: "ring-1 ring-inset ring-emerald-100",
      },
    },
    tenant_pm: {
      label: "Inquilino PM",
      icon: "octicon:organization-24",
      helperText: "Solicitudes disponibles",
      accent: {
        iconBg: "bg-teal-50",
        iconText: "text-teal-600",
        iconRing: "ring-1 ring-inset ring-teal-100",
      },
    },
    identity_verification: {
      label: "Validación de Identidad",
      icon: "streamline:interface-id-user-identification-angle-secure-human-id-person-face-silhouette-security-brackets",
      helperText: "Verificaciones disponibles",
      accent: {
        iconBg: "bg-amber-50",
        iconText: "text-amber-600",
        iconRing: "ring-1 ring-inset ring-amber-100",
      },
    },
    blacklist: {
      label: "Listas Negras",
      icon: "material-symbols:patient-list-rounded",
      helperText: "Consultas disponibles",
      accent: {
        iconBg: "bg-slate-50",
        iconText: "text-slate-600",
        iconRing: "ring-1 ring-inset ring-slate-100",
      },
    },
  };

  const fallbackConfig = (key: string) => ({
    label: key.replace(/_/g, " "),
    icon: "octicon:question-24",
    helperText: "Créditos disponibles",
    accent: {
      iconBg: "bg-slate-50",
      iconText: "text-slate-600",
    },
  });

  const justifyClass = position === "end" ? "justify-end" : "justify-start";

  // Guard against undefined or null credits
  if (!credits || typeof credits !== 'object') {
    return null;
  }

  return (
    <div className="w-full">
      <div className={`flex w-full flex-wrap gap-3 ${justifyClass}`}>
        {Object.entries(credits).map(([key, value]) => {
          const config = creditConfigs[key] ?? fallbackConfig(key);
          return (
            <div
              key={key}
              className="w-full sm:flex-1 sm:min-w-[200px] sm:max-w-[240px]"
            >
              <StatsCard
                text={config.label}
                value={value}
                icon={config.icon}
                helperText={config.helperText}
                accent={config.accent}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CreditCardSection;
